// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-71e277c3] {\n  padding: 2em 1em 1em;\n  text-align: center;\n}\n.logo img[data-v-71e277c3] {\n  margin-bottom: 0.5em;\n}\n.logo .sub-line[data-v-71e277c3] {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #444444;\n  margin: 5px 0px;\n}\n.logo .sub-line a[data-v-71e277c3] {\n  color: #f24a58;\n}", ""]);
// Exports
module.exports = exports;
